import { EventEmitterStatic } from "base/EventEmitter";
import ScriptHelper from "base/ScriptHelper";

export default class TrackingHelper extends EventEmitterStatic {
    static _bind_events() {
        let listeners = {
            scroll: () => TrackingHelper._trigger("scroll"),
            unload: () => {
                if (!TrackingHelper.should_load) {
                    console.warn("Unloading without loading tracking");
                }
            },
            focus: () => TrackingHelper._trigger("focus"),
            timeout: () => TrackingHelper._trigger("timeout"),
            click: () => TrackingHelper._trigger("click"),
            keydown: () => TrackingHelper._trigger("keydown"),
        };

        TrackingHelper.listeners = listeners;

        $(window).on("unload", listeners.unload).on("scroll", listeners.scroll);
        $("body").on("focus", "input,textarea", listeners.focus).on("click", listeners.click).on("keydown", listeners.keydown);
        TrackingHelper._timeout = setTimeout(listeners.timeout, 1000);
    }

    static _trigger(reason) {
        if (TrackingHelper.should_load) {
            return;
        }

        TrackingHelper.should_load = true;

        console.debug("Tracking load triggered: ", reason);
        for (let script of TrackingHelper.scripts) {
            ScriptHelper.load_script(script);
        }

        TrackingHelper.emit("load", reason);
        TrackingHelper._resolve(reason);

        TrackingHelper._unbind_events();
    }

    static _unbind_events() {
        $(window).off("unload", TrackingHelper.listeners.unload).off("scroll", TrackingHelper.listeners.scroll);
        $("body").off("focus", "input,textarea", TrackingHelper.listeners.focus).off("click", TrackingHelper.listeners.click).off("keydown", TrackingHelper.listeners.keydown);
        clearTimeout(TrackingHelper._timeout);
    }

    static init() {
        if (TrackingHelper.initialised) {
            return;
        }

        TrackingHelper.initialised = true;
        TrackingHelper.should_load = false;
        TrackingHelper.scripts = [];
        TrackingHelper.promise = new Promise((resolve) => TrackingHelper._resolve = resolve);

        TrackingHelper._bind_events();
    }

    static register_script(script) {
        TrackingHelper.init();

        // We have already passed the point where we should load, load immediately
        if (TrackingHelper.should_load) {
            ScriptHelper.load_script(script).catch((e) => {
                console.warn("Error when loading tracking script", e);
            });
            return;
        }

        // Schedule script for future loading
        TrackingHelper.scripts.push(script);
    }

    static async wait() {
        TrackingHelper.init();

        return TrackingHelper.promise;
    }
}

TrackingHelper.initialised = false;
